export default "__VITE_ASSET__BJHZ9M8Y__"